var _path, _g, _g2, _circle, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _path11, _g5, _path12, _path13, _g6, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPresentsvgrIcon = function SvgPresentsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 280 322",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__a)",
    fillOpacity: 0.22,
    d: "M50.873 186h168.643L278 323H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#present_svgrIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 131.449,
    r: 131.5,
    fill: "#247FEA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#present_svgrIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138.888,
    cy: 130.838,
    r: 116.209,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "present_svgrIcon_svg__d",
    width: 234,
    height: 234,
    x: 22,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.889,
    cy: 130.838,
    r: 116.209,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#present_svgrIcon_svg__d)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162.575,
    height: 112.066,
    x: 56.616,
    y: 137.428,
    fill: "url(#present_svgrIcon_svg__e)",
    rx: 9.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 181.515,
    height: 50.509,
    x: 47.145,
    y: 107.438,
    fill: "url(#present_svgrIcon_svg__f)",
    rx: 9.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__g)",
    d: "M0 0h26.833v50.509H0z",
    transform: "matrix(1 0 0 -1 124.487 157.946)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__h)",
    d: "M124.487 157.947h26.833v91.547h-26.833z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__i)",
    stroke: "url(#present_svgrIcon_svg__j)",
    strokeWidth: 1.223,
    d: "M184.388 118.885c-.656-6.47-5.471-11.665-11.849-11.666l-14.91-.002-4.989-.001h-1.319l-.012.311c-.02.577-.043 1.414-.052 2.454-.018 2.08.019 4.968.239 8.201.443 6.491 1.62 14.272 4.508 19.704 3.699 6.957 9.298 10.388 12.847 11.956 2.036.901 4.334.931 6.624.525l23.619-4.185c.883-.156 1.464-.903 1.594-1.834.131-.935-.22-1.88-1.019-2.346-2.324-1.355-4.853-3.028-7.07-4.951-2.211-1.917-4.145-4.111-5.237-6.512-1.763-3.881-2.594-7.903-2.974-11.654Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__k)",
    d: "M174.443 57.061c-7.622 1.531-14.479 5.768-18.683 12.308-4.798 7.466-10.357 17.373-10.357 23.204v15.052h31.406s1.596-10.317 1.596-24.522c0-14.206-3.962-26.042-3.962-26.042"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "present_svgrIcon_svg__m",
    width: 34,
    height: 51,
    x: 145,
    y: 57,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__l)",
    d: "M174.442 57.061c-7.622 1.531-14.479 5.768-18.683 12.308-4.798 7.466-10.357 17.373-10.357 23.204v15.052h31.406s1.596-10.317 1.596-24.522c0-14.206-3.962-26.042-3.962-26.042"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#present_svgrIcon_svg__m)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.802,
    cy: 75.57,
    fill: "url(#present_svgrIcon_svg__n)",
    rx: 33.639,
    ry: 24.465,
    transform: "rotate(-48 180.802 75.57)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__o)",
    stroke: "url(#present_svgrIcon_svg__p)",
    strokeWidth: 1.223,
    d: "M172.991 59.34c.13-1.1.985-1.862 1.903-1.753 6.626.783 13.711 4.585 18.353 7.538 3.024 1.923 4.48 5.466 3.74 8.983-1.076 5.11-3.079 12.568-6.491 18.985-2.908 5.468-6.399 8.969-9.152 11.1a25 25 0 0 1-3.415 2.244 16 16 0 0 1-1.218.593h-30.064a399 399 0 0 0 6.563-9.077c4.013-5.716 8.782-12.846 11.754-18.435 5.046-9.49 7.438-15.175 8.027-20.177Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "present_svgrIcon_svg__s",
    width: 53,
    height: 52,
    x: 145,
    y: 56,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__q)",
    stroke: "url(#present_svgrIcon_svg__r)",
    strokeWidth: 1.223,
    d: "M172.99 59.34c.13-1.1.985-1.862 1.904-1.753 6.625.783 13.71 4.585 18.352 7.538 3.024 1.923 4.48 5.466 3.74 8.983-1.076 5.11-3.079 12.568-6.491 18.985-2.908 5.468-6.398 8.969-9.152 11.1a25 25 0 0 1-3.415 2.244 16 16 0 0 1-1.218.593h-30.064a411.782 411.782 0 0 0 6.563-9.077c4.013-5.716 8.782-12.846 11.754-18.435 5.046-9.49 7.438-15.175 8.027-20.177Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#present_svgrIcon_svg__s)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.197,
    cy: 63.559,
    fill: "url(#present_svgrIcon_svg__t)",
    rx: 33.639,
    ry: 24.465
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__u)",
    stroke: "url(#present_svgrIcon_svg__v)",
    strokeWidth: 1.223,
    d: "M91.18 118.885c.655-6.47 5.471-11.665 11.849-11.666l14.91-.002 4.988-.001h1.32l.011.311c.021.577.044 1.414.053 2.454.018 2.08-.019 4.968-.239 8.201-.443 6.491-1.62 14.272-4.508 19.704-3.699 6.957-9.298 10.388-12.847 11.956-2.036.901-4.334.931-6.625.525l-23.618-4.185c-.883-.156-1.464-.903-1.595-1.834-.13-.935.22-1.88 1.02-2.346 2.324-1.355 4.853-3.028 7.07-4.951 2.21-1.917 4.145-4.111 5.236-6.512 1.764-3.881 2.595-7.903 2.975-11.654Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__w)",
    d: "M101.125 57.061c7.622 1.531 14.479 5.768 18.682 12.308 4.799 7.466 10.358 17.373 10.358 23.204v15.052H98.759s-1.596-10.317-1.596-24.522c0-14.206 3.962-26.042 3.962-26.042"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "present_svgrIcon_svg__y",
    width: 34,
    height: 51,
    x: 97,
    y: 57,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__x)",
    d: "M101.126 57.06c7.622 1.532 14.479 5.769 18.682 12.308 4.799 7.466 10.358 17.373 10.358 23.205v15.051H98.76s-1.596-10.316-1.596-24.522 3.962-26.041 3.962-26.041"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#present_svgrIcon_svg__y)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.845,
    cy: 85.356,
    fill: "url(#present_svgrIcon_svg__z)",
    rx: 33.639,
    ry: 24.465,
    transform: "rotate(-48 98.845 85.356)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__A)",
    stroke: "url(#present_svgrIcon_svg__B)",
    strokeWidth: 1.223,
    d: "M102.577 59.34c-.13-1.1-.985-1.862-1.904-1.753-6.626.783-13.71 4.585-18.352 7.538-3.025 1.923-4.48 5.466-3.74 8.983 1.076 5.11 3.08 12.568 6.491 18.985 2.907 5.468 6.398 8.969 9.152 11.1a25 25 0 0 0 3.415 2.244 15 15 0 0 0 1.218.593h30.064a417.935 417.935 0 0 1-6.563-9.077c-4.013-5.716-8.782-12.846-11.754-18.435-5.046-9.49-7.438-15.175-8.027-20.177Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "present_svgrIcon_svg__E",
    width: 54,
    height: 52,
    x: 77,
    y: 56,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__C)",
    stroke: "url(#present_svgrIcon_svg__D)",
    strokeWidth: 1.223,
    d: "M102.578 59.34c-.13-1.1-.985-1.862-1.904-1.753-6.626.783-13.71 4.585-18.352 7.538-3.025 1.923-4.48 5.466-3.74 8.983 1.076 5.11 3.079 12.568 6.491 18.985 2.907 5.468 6.398 8.969 9.152 11.1a25 25 0 0 0 3.415 2.244 15 15 0 0 0 1.218.593h30.064a417.935 417.935 0 0 1-6.563-9.077c-4.013-5.716-8.782-12.846-11.754-18.435-5.046-9.49-7.438-15.175-8.027-20.177Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#present_svgrIcon_svg__E)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.134,
    cy: 63.559,
    fill: "url(#present_svgrIcon_svg__F)",
    rx: 33.639,
    ry: 24.465
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#present_svgrIcon_svg__G)",
    d: "M126.031 103.937a11.05 11.05 0 0 1 10.88-9.126h2.504c5.126 0 9.578 3.525 10.754 8.514l1.151 4.882h-26.044z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__a",
    x1: 146.498,
    x2: 152.802,
    y1: 242.066,
    y2: 370.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BBBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__e",
    x1: 138.693,
    x2: 137.903,
    y1: 120.854,
    y2: 249.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#5199EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#8CBCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__f",
    x1: 138.784,
    x2: 138.64,
    y1: 99.968,
    y2: 157.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5199EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__g",
    x1: 18.576,
    x2: 18.684,
    y1: 50.509,
    y2: -7.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__h",
    x1: 143.063,
    x2: 143.063,
    y1: 249.493,
    y2: 135.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#C7B8FD",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#7DB3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__i",
    x1: 169.645,
    x2: 172.802,
    y1: 88.465,
    y2: 154.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#FFE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#67A6F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__j",
    x1: 176.809,
    x2: 148.674,
    y1: 101.48,
    y2: 156.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__k",
    x1: 174.975,
    x2: 168.134,
    y1: 83.742,
    y2: 59.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__l",
    x1: 174.974,
    x2: 168.133,
    y1: 83.742,
    y2: 59.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__p",
    x1: 188.891,
    x2: 160.248,
    y1: 61.654,
    y2: 115.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__r",
    x1: 188.89,
    x2: 160.247,
    y1: 61.654,
    y2: 115.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__u",
    x1: 105.922,
    x2: 102.766,
    y1: 88.465,
    y2: 154.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#FFE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#67A6F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__v",
    x1: 98.759,
    x2: 126.894,
    y1: 101.48,
    y2: 156.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__w",
    x1: 100.593,
    x2: 107.434,
    y1: 83.742,
    y2: 59.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__x",
    x1: 100.594,
    x2: 107.435,
    y1: 83.742,
    y2: 59.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__B",
    x1: 86.677,
    x2: 115.32,
    y1: 61.654,
    y2: 115.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__D",
    x1: 86.678,
    x2: 115.321,
    y1: 61.654,
    y2: 115.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "present_svgrIcon_svg__G",
    x1: 142.56,
    x2: 143.171,
    y1: 106.984,
    y2: 93.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#EDF4FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3364 20.03848 -29.1364 .48915 185.007 71.143)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7B7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-140.194 98.409 25.578)scale(12.3277 44.1402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-140.194 98.408 25.578)scale(12.3277 44.1402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3364 20.03848 -29.1364 .48915 180.402 59.132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7B7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3364 20.03848 -29.1364 .48915 103.05 80.929)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7B7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.47041 -7.89199 28.25783 33.90948 117.935 108.227)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.47041 -7.89199 28.25783 33.90948 117.936 108.227)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "present_svgrIcon_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3364 20.03848 -29.1364 .48915 103.339 59.132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7B7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "present_svgrIcon_svg__b",
    width: 263,
    height: 265.447,
    x: 8,
    y: -0.051,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.34
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.956863 0 0 0 0 0.87451 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_159_150345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "present_svgrIcon_svg__c",
    width: 303.367,
    height: 303.367,
    x: -12.796,
    y: -28.186,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.737
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.666667 0 0 0 0 0.803922 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_159_150345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_159_150345",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPresentsvgrIcon);
export default ForwardRef;